const pad2 = (n) => String(n).padStart(2, '0');

export const utcDateString = (d) =>
  `${d.getUTCFullYear()}-${pad2(d.getUTCMonth() + 1)}-${pad2(d.getUTCDate())}`;

export const firstOfThisUTCMonth = () => {
  const t = new Date();
  return `${t.getUTCFullYear()}-${pad2(t.getUTCMonth() + 1)}-01`;
};

// The first day of a window of `days` days ending today, both ends inclusive.
export const daysAgoUTC = (days) => {
  const t = new Date();
  t.setUTCDate(t.getUTCDate() - (days - 1));
  return utcDateString(t);
};

export const todayUTC =() => utcDateString(new Date());

export const formatUTCDate = (iso) => {
  const d = new Date(iso);
  return Number.isNaN(d.getTime())
    ? '—'
    : d.toLocaleDateString(undefined, { timeZone: 'UTC' });
};
